"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbsIdIcon = BreadcrumbsIdIcon;
exports.BreadcrumbsItem = BreadcrumbsItem;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _breadcrumbs = require("@react-aria/breadcrumbs");
var _Icon = require("../../../../deprecated/atoms/Icon");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ColoredIdIcon = _interopRequireDefault(require("./ColoredIdIcon"));
var _globalTokens = require("../../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledItem = _styledComponents.default.li.withConfig({
  displayName: "Breadcrumbs__StyledItem",
  componentId: "sc-5l7wfx-0"
})(["display:flex;", ";", ";color:", ";"], function (props) {
  return props.isCurrent || props.isDisabled ? 'cursor: default' : '';
}, _tokens.default.sky.sys.font.subheading['1'], _tokens.default.sky.sys.color.text.content.main);
var StyledOl = _styledComponents.default.ol.withConfig({
  displayName: "Breadcrumbs__StyledOl",
  componentId: "sc-5l7wfx-1"
})(["display:flex;list-style:none;margin:0;padding:0;align-items:center;"]);
var StyledSeparatorWrapper = _styledComponents.default.div.withConfig({
  displayName: "Breadcrumbs__StyledSeparatorWrapper",
  componentId: "sc-5l7wfx-2"
})(["display:flex;align-items:center;padding:0 ", ";"], _globalTokens.globalSpacing['200']);
var Breadcrumbs = function Breadcrumbs(props) {
  var _ref2 = (0, _breadcrumbs.useBreadcrumbs)(props),
    navProps = _ref2.navProps;
  var children = _react.default.Children.toArray(props.children);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", _objectSpread({}, navProps, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledOl, {
      children: children.map(function (child, i) {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          isCurrent: i === children.length - 1
        });
      })
    })
  }));
};
function BreadcrumbsItem(props) {
  var ref = _react.default.useRef();
  var _ref3 = (0, _breadcrumbs.useBreadcrumbItem)(props, ref),
    itemProps = _ref3.itemProps;
  var child = _react.default.Children.only(props.children);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledItem, _objectSpread({}, props, {
    children: [/*#__PURE__*/_react.default.cloneElement(child, _objectSpread({}, itemProps, {
      ref: ref,
      style: _objectSpread({
        display: 'flex',
        alignItems: 'center',
        gap: _globalTokens.globalSpacing['200']
      }, child.props.style)
    }, child.props)), !props.isCurrent && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSeparatorWrapper, {
      "aria-hidden": "true",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: 'chevronLRight',
        size: "s"
      })
    })]
  }));
}

/* deprecated - replaced by WorkSignifier  will be removed */
function BreadcrumbsIdIcon(_ref) {
  var children = _ref.children,
    color = _ref.color;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ColoredIdIcon.default, {
    color: color,
    children: children
  });
}
Breadcrumbs.IdIcon = BreadcrumbsIdIcon;
Breadcrumbs.Item = BreadcrumbsItem;
var _default = exports.default = Breadcrumbs;